import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const quotesVariants = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
	},
	exit: {
		opacity: 0,
	},
	transition: {
		duration: 1,
		delay: 2,
	},
};

const DailyQuotes = () => {
	const [quote, setQuote] = useState("");
	const [author, setAuthor] = useState("");

	useEffect(() => {
		const fetchQotd = async () => {
			try {
				const response = await fetch(
					"https://official-joke-api.appspot.com/random_joke"
				);
				const data = await response.json();
				setQuote(data.setup);
				setAuthor(data.punchline);
			} catch (err) {
				console.log(err);
			}
		};

		fetchQotd();
	}, []);

	return (
		<motion.div
			className="flex flex-col items-center lg:items-end my-5 gap-1"
			variants={quotesVariants}
			{...quotesVariants}>
			<h4 className="text-md italic">"{quote}"</h4>
			<h4 className="text-md italic">"{author}"</h4>
		</motion.div>
	);
};

export default DailyQuotes;
